import { ColorRecipeModel } from '../../models/color-recipe.model';
import { EngineColorRecipeModel } from '../../models/engine-color-recipe.model';
import { PaintBrushMode } from '../../models/paint-brush-mode.enum';
import { PaintPaletteModel } from '../../models/paint-palette.model';

export class SetCurrentRecipe {
  static readonly type = '[Edit Paint] Set Color Recipe';
  constructor(public colorRecipe: ColorRecipeModel) {}
}

export class SetPaintBrushMode {
  static readonly type = '[Edit Paint] Set Paint Brush Mode';
  constructor(public brushMode: PaintBrushMode) {}
}

export class ClearCurrentRecipe {
  static readonly type = '[Edit Paint] Clear Current Recipe';
  constructor() {}
}

export class ResetPaint {
  static readonly type = '[Edit Paint] Reset Paint';
  constructor() {}
}

export class AddRecentRecipe {
  static readonly type = '[Edit Paint] Add Recent Recipe';
  constructor(public recipe: EngineColorRecipeModel) {}
}

export class SetRecentRecipes {
  static readonly type = '[Edit Paint] Set Recent Recipes';
  constructor(public recipes: EngineColorRecipeModel[]) {}
}

export class ResetStoryRecipes {
  static readonly type = '[Edit Paint] Reset Story Recipes';
  constructor() {}
}

export class SetStoryRecipesForChapter {
  static readonly type = '[Edit Paint] Set Story Recipes For Chapter';
  constructor(public chapterId: string, public recipes: EngineColorRecipeModel[]) {}
}

export class AddPalette {
  static readonly type = '[Edit Paint] Add Palette';
  constructor(public palette: PaintPaletteModel) {}
}

export class RemovePalette {
  static readonly type = '[Edit Paint] Remove Palette';
  constructor(public paletteId: string) {}
}

export class UpdatePalette {
  static readonly type = '[Edit Paint] Update Palette';
  constructor(public palette: PaintPaletteModel) {}
}

export class SetPalettes {
  static readonly type = '[Edit Paint] Set Palettes';
  constructor(public palettes: PaintPaletteModel[]) {}
}

export class AddRecipeToPalette {
  static readonly type = '[Edit Paint] Add Recipe to Palette';
  constructor(public recipe: ColorRecipeModel, public paletteId: string) {}
}

export class TogglePalette {
  static readonly type = '[Edit Paint] Toggle Palette';
  constructor(public paletteId: string, public open?: boolean) {}
}
